import AuthService from '../../state/auth.service';
import axios from 'axios';

import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    // upload(file) {
    //     console.log("Got ", file);
    //     let headers = getHeaders();
    //     delete headers['Accept'];
    //     headers['Content-Type'] = 'multipart/form-data';
    //     console.log("headers:", headers);
    //     const data = new FormData();
    //     data.append('file', file, file.name);
    //     data.append('content-type', file.type);
    //     console.log('data', data);
    //     console.log('form data file', data.get('file'));
    //     console.log('form data content-type', data.get('content-type'));

    //     return axios.post(`${endpoints.FILE_BASE}/upload`, data, {
    //         headers: headers
    //     }).then(response => {
    //         return response.data;
    //     });
    // },

    getFile(id) {
        return axios
            .get(endpoints.FILE_BASE, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getAllFiles(org_id) {
        return axios
            .get(`${endpoints.FILE_BASE}s/${org_id}`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },

    listFiles(criterion_id) {
        return axios
            .get(`${endpoints.FILE_BASE}s`, {
                headers: getHeaders(),
                params: {
                    criterion_id: criterion_id,
                },
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },

    getUploadURL(criterion_number) {
        console.log(`Criterion number: ${criterion_number}`);
        return axios
            .post(
                `${endpoints.FILE_BASE}/generate_upload_link`,
                {
                    criterion_number: criterion_number,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
    getDownloadURL(criterion_number, filename, fileId) {
        return axios
            .get(`${endpoints.FILE_BASE}s/generate_download_link`, {
                headers: getHeaders(),
                params: {
                    criterion_number: criterion_number,
                    filename: filename,
                    fileId: fileId,
                },
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
    deleteFile(criterion_number, filename) {
        return axios
            .delete(`${endpoints.FILE_BASE}`, {
                headers: getHeaders(),
                params: {
                    criterion_number: criterion_number,
                    filename: filename,
                },
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
    putFile(url, file, onUploadProgress) {
        const config = {
            onUploadProgress: onUploadProgress,
        };
        return axios.put(url, file, config).then(response => {
            if (response.data) {
                return response.data;
            } else {
                return 'ok';
            }
        }); // need to catch outside of this
    },
    postFileMetadata(criterion_number, s3_id, filename) {
        return axios
            .post(
                `${endpoints.FILE_BASE}`,
                {
                    criterion_id: criterion_number,
                    s3_id: s3_id,
                    file_key: filename,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
    removeFile() {
        console.error('NEED TO IMPLEMENT DELETE!!');
        // return axios.get(`${endpoints.FILE_BASE}s`, {
        //     headers: getHeaders()
        // }).then(response => {
        //     if (response.data) {
        //         return response.data;
        //     }
        // });
    },
    downloadAllFiles(files, org) {
        return axios
            .post(
                `${endpoints.FILE_BASE}s/download_all`,
                {
                    files: files,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                }
            });
    },
};
